'use client';

import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import * as React from 'react';
import { cn } from '@/shared/lib/utils';
import { Skeleton } from 'shared/ui/skeleton';
const Checkbox = React.forwardRef<React.ElementRef<typeof CheckboxPrimitive.Root>, React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>>(({
  className,
  ...props
}, ref) => <CheckboxPrimitive.Root ref={ref} className={cn('peer size-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground', className)} {...props}>
    <CheckboxPrimitive.Indicator className={cn('flex items-center justify-center text-current')}>
      <Check className="size-4" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>);
Checkbox.displayName = CheckboxPrimitive.Root.displayName;
const CheckboxSkeleton = () => <div className="flex flex-row items-center space-x-4 space-y-0 justify-center" data-sentry-component="CheckboxSkeleton" data-sentry-source-file="checkbox.tsx">
    <Skeleton className="h-3 w-16" data-sentry-element="Skeleton" data-sentry-source-file="checkbox.tsx" />
    <Skeleton className="size-4" data-sentry-element="Skeleton" data-sentry-source-file="checkbox.tsx" />
  </div>;
export { Checkbox, CheckboxSkeleton };